// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import ElementUI from './plugins/elementui';
import App from './App';
import store from './store'
import router from './router';
import i18n from './i18n/i18n';
import Global from '@u/global';
import dayjs from "dayjs";

// 守卫路由
import "./router/permit";

Vue.use(ElementUI);
Vue.use(Global);

Vue.prototype.$dayjs = dayjs;
i18n.locale = sessionStorage.getItem('lang') || 'en';
/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js